import { render, staticRenderFns } from "./FlexTwoColumns.vue?vue&type=template&id=7ad98278&scoped=true"
import script from "./FlexTwoColumns.vue?vue&type=script&lang=js"
export * from "./FlexTwoColumns.vue?vue&type=script&lang=js"
import style0 from "./FlexTwoColumns.vue?vue&type=style&index=0&id=7ad98278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad98278",
  null
  
)

export default component.exports